import { Category } from 'infra/type'
import { makeAutoObservable } from 'mobx'

class CategoryStore {
  raw: Category[] = []
  data: Map<Number, Category> = new Map()

  constructor() {
    makeAutoObservable(this)
  }

  initData(data: Category[]) {
    this.raw = data
    this.data.clear()
    data.forEach((c1) => {
      this.data.set(c1.id, c1)
      c1.sub_categories?.forEach((c2) => {
        c2.parentCategoryId = c1.id
        this.data.set(c2.id, c2)
      })
    })
  }

  getCategoryIdTree(categoryId?: number, outputArray: number[] = []): number[] {
    if (!categoryId) return outputArray
    const currentCategory = this.data.get(categoryId)
    if (!currentCategory) return outputArray
    return [
      ...this.getCategoryIdTree(currentCategory.parentCategoryId, outputArray),
      categoryId,
    ]
  }

  formatCategoryIds(categoryIds: number[]): string {
    return categoryIds
      .map((x) => this.data.get(x)?.name || '알수없음')
      .join('  >  ')
  }
}

export const categoryStore = new CategoryStore()
